<template>
  <div class="card pa-20">
    <section class="card-content px-0">
      <p class="has-text-grid-1 is-size-14px has-text-weight-bold mb-5">
        {{ $t('header.viderPanier.titre') }}
      </p>
      <p class="has-text-default is-size-7">
        {{ $t('header.viderPanier.message') }}
      </p>
    </section>
    <footer class="has-text-centered mt-10">
      <b-button
        type="is-transparent"
        class="has-text-default"
        @click="$emit('annuler')">
        {{ $t('header.viderPanier.non') }}
      </b-button>
      <b-button
        type="is-primary"
        class="has-text-weight-bold ml-20"
        @click="$emit('confirmer')">
        {{ $t('header.viderPanier.oui') }}
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ModalViderPanier',
};
</script>
